<template>
  <div class="container">
    <v-data-table
      :headers="headers"
      :items="items"
      sort-by="calories"
      class="elevation-1"
      disable-pagination
      disable-filtering
      hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Οχήματα</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                ΔΗΜΙΟΥΡΓΙΑ
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="8" sm="6">
                      <v-text-field
                        v-model="editedItem.plates"
                        label="Πινακίδα"
                        v-bind:error-messages="allerrors.plates">
                      </v-text-field>
                      <v-select
                        label="Οδηγός"
                        v-model="editedItem.driver_id"
                        v-bind:items="drivers"
                        item-text="name"
                        item-value="id"
                        clearable
                        v-bind:error-messages="allerrors.driver_id">
                      </v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="close">ΑΚΥΡΟ</v-btn>
                <v-btn color="blue darken-1" text @click="save" v-bind:loading="saveButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Διαγραφή εγγραφής "{{ editedItem.plates }}";</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" text @click="deleteItemConfirm" v-bind:loading="deleteButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: 'Πινακίδα',
          align: 'start',
          //sortable: false,
          value: 'plates',
        },
        { 
          text: 'Οδηγός', 
          value: 'driver.name' 
        },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      allerrors: [],
      items: [],
      drivers: [],
      vehicles: [],
      editedIndex: -1,
      editedItem: {
        plates: '',
        driver_id: null,
      },
      defaultItem: {
        plates: '',
        driver_id: null
      },
      saveButtonDisabled: false,
      deleteButtonDisabled: false
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Προσθήκη' : 'Επεξεργασία'
      },

      editedItemName () {
        return 'yay'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      mixmatch(vehicle) {
        vehicle.driver = this.drivers.find(driver => driver.id == vehicle.driver_id)
        return vehicle;
      },

      initialize () {
        axios.all([
          axios.get('/api/vehicles/'),
          axios.get('/api/drivers')
        ])
        .then(axios.spread((vehiclesResponse, driversResponse) => {
          this.drivers = driversResponse.data
          this.vehicles = vehiclesResponse.data
          
          this.vehicles.map(vehicle => this.mixmatch(vehicle))

          this.items = this.vehicles
        }))
        .catch(error => { console.log(error) })
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.deleteButtonDisabled = true;
        axios.delete(`/api/vehicles/${this.items[this.editedIndex].id}`)
        .then(response => { this.items.splice(this.editedIndex, 1); this.closeDelete(); })
        .catch(error => console.log(error))
        .finally(() => this.deleteButtonDisabled = false)
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        this.saveButtonDisabled = true;
        
        let requestBody = {
          plates: this.editedItem.plates,
          driver_id: this.editedItem.driver_id
        }

        if (this.editedIndex > -1) {
          //Object.assign(this.items[this.editedIndex], this.editedItem)
          axios.patch(`/api/vehicles/${this.editedItem.id}`, requestBody )
          .then(response => { Object.assign(this.items[this.editedIndex], this.mixmatch(response.data)); this.close(); })
          .catch(error => {
            console.log(error)

            if (error.response.data)
              this.allerrors = error.response.data.errors

          })
          .finally(() => this.saveButtonDisabled = false)
        } else {

          axios.post('/api/vehicles', requestBody )
          .then(response => { console.log(response.data); this.items.push(this.mixmatch(response.data)); this.close(); })
          .catch(error => {
            console.log(error)

            if (error.response.data)
              this.allerrors = error.response.data.errors

          })
          .finally(() => this.saveButtonDisabled = false)
          
        }
      },
    },
  }
</script>

<style>
</style>